import * as actionTypes from "./actionTypes";

export const get_customers = (payload)=>{
    return {
        type: actionTypes.GET_CUSTOMERS,
        payload: payload
    }
}